<template>
  <div id="paket-psikotes" style="min-height:650px;">
    <v-container grid-list-xl fluid>
      <div class="headline">
        <v-icon>developer_board</v-icon>&nbsp;Paket Psikotes
      </div>
      <v-divider></v-divider>

      <v-card min-height="500px" class="elevation-1 pl-2 pt-2">
        <v-layout align-start justify-start row wrap>
          <v-flex md12 v-for="(row,index) in dataPackageList" :key="row.Id">
            <table class="exercise-status-border exercise-status-leftborder" style="width:90%">
              <tr>
                <td style="width:2%">
                  <span class="subheading pl-2">{{index + 1}}.</span>
                </td>
                <td style="width:20%">
                  <span class="subheading">{{row.name }}</span>
                </td>
                <td style="width:60%">
                  <span class="subheading">{{row.description}}</span>
                </td>
                <td style="width:10%">
                  <table>
                    <tr>
                      <td>
                        <v-btn
                          :loading="isLoading"
                          small
                          round
                          color="purple"
                          dark
                          class="elevation-1"
                          @click="ambilPaket(row)"
                        >Ambil Paket</v-btn>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>

    <!-- Dialong Print -->
    <!-- <v-dialog v-model="dialogPrint" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary" class="elevation-2">
          <v-btn icon dark @click="dialogPrint = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Printing Excercise</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items></v-toolbar-items>
        </v-toolbar>
        <div style="height:650px;">
          {{printExerciseCode}}
          <iframe
            id="printExcercise"
            width="100%"
            height="600"
            frameborder="0"
            :src="printSource"
          ></iframe>
        </div>
      </v-card>
    </v-dialog>-->
    <full-page-loading :value="isLoadingFullPage" message="Tunggu! sedang loading data"></full-page-loading>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ApiService from "@/common/api.service";
import { format, getYear } from "date-fns";
// import { ACTION_PSI_EXERCISE_START } from "@/store/actions.type";
import { MUTATION_PSI_BERSEDIA_PACKET_ID } from "@/store/mutations.type";

export default {
  name: "paket-psikotes",
  components: {
    "full-page-loading": () => import("../../components/FullPageLoading")
  },
  data() {
    return {
      isLoadingFullPage: false,
      dataPackageList: [],
      dialogPrint: false,
      printExerciseCode: "",
      printSource: "",
      isLoading: false
    };
  },
  filters: {
    date: function(value) {
      return format(new Date(value), "DD-MM-YYYY");
    }
  },
  computed: {
    ...mapState({
      currentMember: state => state.auth.currentMember
    })
  },
  mounted() {
    this.init();
  },
  methods: {
    printSertifikat: function(param) {
      let paramValue = {
        PsiExerciseId: param.id
      };

      this.printSource =
        process.env.VUE_APP_PRINTING_URI +
        "PsikoSertifikat.aspx?param=" +
        JSON.stringify(paramValue);

      this.dialogPrint = true;
    },
    init: function() {
      
      const vm = this;
      vm.isLoadingFullPage = true;

      ApiService.post("DataPackage/AmbilPaket_GetDataPaket",{
        user_id:vm.$store.state.auth.user.id
      })
        .then(response => {
          vm.dataPackageList = response.data;
        })
        .catch(({ response }) => {})
        .finally(() => {
          // setTimeout(() => console.log("timeout"), 3000);
          vm.isLoadingFullPage = false;
        });
    },
    ambilPaket: function(dataPaket) {      
      let errorMessage = "";

      if (this.currentMember.tingkat_pendidikan === null) {
        errorMessage += " Tingkat Pendidikan,";
      }

      if (this.currentMember.jenis_kelamin === "") {
        errorMessage += " Jenis kelamin,";
      }

      if (getYear(new Date(this.currentMember.tanggal_lahir)) === 1900) {
        errorMessage += " Tanggal Lahir,";
      }

      if (errorMessage !== "") {
        window.getApp.$emit(
          "APP_MESSAGE_WARNING",
          "Update biodata " + errorMessage
        );
        return;
      }

      this.$store.commit(MUTATION_PSI_BERSEDIA_PACKET_ID, dataPaket.id);
      this.$router.push({ name: "aplikasi/kesediaan-dan-kesepakatan" });

      // this.isLoadingFullPage = true;

      // this.$store.dispatch(ACTION_PSI_EXERCISE_START,dataPaket.id).then(() => {
      //     this.isLoadingFullPage = false;
      //   this.$router.push({
      //     name: "aplikasi/PsikoExercise/PsikoExerciseHome"
      //   });
      // });
    }
  }
};
</script>
<style lang="stylus">
.data-list-left {
  width: 110px;
}

#fileInput {
  display: none;
}

.media-menu {
  min-width: 260px;
  border-right: 1px solid #eee;
  min-height: calc(100vh - 50px - 64px);
}

.media-detail {
  min-width: 300px;
  border-left: 1px solid #eee;
}

.exercise-status-border {
  border-left: 5px solid green;
  border-top: 1px solid green;
  border-right: 1px solid green;
  border-bottom: 1px solid green;
  border-radius: 0 15px 15px 0;
}

.exercise-status-leftborder {
  border-left: 4px solid #3cd1c2;
}

.project.open {
  border-left: 4px solid #ffaa2c;
}

.project.overdue {
  border-left: 4px solid #f83e70;
}

.exercise-status-vchip {
  background: #3cd1c2;
}
</style>